// /src/renderer/constants/labels.ts

export const BUTTON_LABELS = {
  submit: 'Submit',
  cancel: 'Cancel',
};

export const MODAL_LABELS = {
  alertTitle: 'Alert',
  actionConfirm: 'Confirm',
  actionCancel: 'Cancel',
};

// 모달리티
export const MODALITY_NAMES = {
  empty: 'empty',
  CT: 'CT',
  // XA : "XA",
  // MRI : "MRI",
};
export type Modality = keyof typeof MODALITY_NAMES;

// 브라우저
export const BROWSER_LIST_CONTEXT_MENU_NAMES = {
  delete: 'Delete',
  export: 'Export',
  recalc: 'ReCalculate',
  ctffr: 'CT-FFR',
  generateData: 'Generate Data',
  sendToPacs: 'Send to PACS',
};

// 레이아웃 내부의 패널명
export const PANEL_NAMES = {
  EmptyPanel: 'EmptyPanel',
  DICOMPanel: 'DICOMPanel',
  VRPanel: 'VRPanel',
  Surface3DPanel: 'Surface3DPanel',
  CPRPanel: 'CPRPanel',
  CrossSectionPanel: 'CrossSectionPanel',
  ReportPanel: 'ReportPanel',
  PlotPanel: 'PlotPanel',
};

// 분석 목록, db 이상의 값
export const EMPTY_ANALYSIS_TYPE_NAMES = {
  empty: 'Empty',
};
// export const CT_ANALYSIS_TYPE_NAMES = {
//   preview: 'Preview',
//   MPR: 'Multi-Planar Reconstruction',
//   segmentation: 'Segmentation',
//   aorticValveCalcium : 'Aortic Valve Calcium Score',
//   chamber : 'Chamber View',
//   calciumScore : 'Coronary Artery Calcium Score',
//   ejectionFraction : 'Ejection fraction',
//   fai : 'Fat Attenuation Index',
//   isr : 'In-Stent Restenosis',
//   myocardial : 'Myocardial mass at risk',
//   wallthickness : 'Left Atrial Wall Thickness',
//   plaque : 'Plaque',
//   stenosis : 'Stenosis'
// };

export const CT_ANALYSIS_TYPE_NAMES = {
  preview: 'Preview',
  MPR: 'Multi-Planar Reconstruction',
  chamber: 'Chamber View',
  segmentation: 'Segmentation',
  plaque: 'Plaque',
  stenosis: 'Stenosis',
  calciumScore: 'Coronary Artery Calcium Score',
  aorticValveCalcium: 'Aortic Valve Calcium Score',
  fai: 'Fat Attenuation Index',
  isr: 'In-Stent Restenosis',
  myocardial: 'Myocardial Mass at Risk',
  wallthickness: 'Left Atrial Wall Thickness',
  ejectionFraction: 'Ejection fraction',
  tavi: 'Transcatheter Aortic Valve Implantation',
  FFR: 'CT-FFR',
};


type AnalysisTypeNames = Record<string, string>;
export const ANALYSIS_TYPE_NAMES: Record<Modality, AnalysisTypeNames> = {
  empty: {
    ...EMPTY_ANALYSIS_TYPE_NAMES,
  },
  CT: {
    ...CT_ANALYSIS_TYPE_NAMES,
  },
};
// 툴 타이틀
export const TOOL_GROUP_NAMES = {
  blank: '',
  // recommended: 'Recommended',
  navigation: 'Navigation',
  display: 'Display',
  rotation: 'Rotation',
  measurement: 'Measurement',
  annotation: 'Annotation',
  cine: 'Cine',
  synchronizing: 'MPR Sync',
  removal: 'Removal',
  segmentManager: 'Segment Manager',
  export: 'Export',
  report: 'Report',
  utilities:'Utilities',
  // 임시
  reset : 'Reset',
  moretools : 'More Tools',
  autocapture : 'AutoCapture',
  modification : 'Modification'
};

// 세팅 탭
export const SETTING_TAB_NAMES = {
  general: 'General',
  pacsConnection: 'PACS Connection',
  account: 'Account',
  jobqueue: 'Job Queue',
  settings: 'Settings',
} as const;

// 패널의 컴포넌트키 이름
export const PANEL_COMPONENT_KEY_NAMES = {
  Empty: 'Empty',
  Axial: 'Axial',
  Coronal: 'Coronal',
  Sagittal: 'Sagittal',
  VR: 'VR',
  Surface3D: 'Surface3D',
  WallThickness: 'WallThickness',
  Report: 'Report',
  CPR: 'CPR',
  CrossSection: 'CrossSection',
  Graph: 'Graph',
  Histogram : 'Histogram',
  FourChamber : 'FourChamber',
  TwoChamber : 'TwoChamber',
  ShortAxis : 'ShortAxis',
  Direction : 'Direction'
} as const;

// 패널에 보여지는 텍스트
export const PANEL_ADJUSTMENT_NAMES = {
  projection: 'Projection',
  zoom: 'Zoom',
  thickness: 'ST',
  spacing: 'Spacing',
  imageSize: 'ImageSize',
  preset: 'Preset',
  additionalSlice: 'AdditionalSlice',
  cArmAngles:'CArmAngles'
} as const;

//모달에 표시될 친구들
export const REPORT_MODAL_NAMES = {
  lawall: {
    title: 'Left Atrial Wall Thickness Analysis Report'
  },
  myocardial: {
    title: "Myocardial Mass at Risk Report",
    sections: {
      totalAnalysis: {
        title: "Total Coronary Artery & LV Analysis",
        columns: ["Metric", "Value"],
        labels: {
          coronaryArteryTotalVolume: "Coronary Artery Total Volume",
          lvMuscleMass: "LV Muscle Mass",
          vmRatio: "V/M Ratio",
        },
      },
      lvMassDistribution: {
        title: "LV Muscle Mass Distribution by Vessel",
        columns: ["Vessel", "Mass (g)", "Percentage"],
        labels: {
          rca: "RCA",
          lad: "LAD",
          lcx: "LCX",
        },
      },
      myocardialMassAtRisk: {
        title: "Myocardial Mass at Risk (Selected Location)",
        columns: ["Metric", "Value"],
        labels: {
          coronaryVolume: "Coronary Volume",
          lvMuscleMass: "LV Muscle Mass",
          vmRatio: "V/M Ratio",
        },
      },
    },
  },
  avc : {
    title: "Aortic Valve Calcium Score Analysis Report",
    sections: {
      crossSection: {
        title: "Cross Section",
        angles: {
          angle0: "0°",
          angle120: "120°",
          angle240: "240°",
        },
      },
      model3d: {
        title: "3D Model",
        labels: {
          avcScore: "AVC Score",
          volume: "Volume (mm³)",
        },
      },
    },
  },
  cac: {
    title: "Coronary Artery Calcium Score Analysis Report",
    sections: {
      images: {
        title: "Images",
        labels: {
          threeD: "3D View",
          axial: "Axial View",
        },
      },
      names: {
        threedmodel : "3D MODEL",
        axialview : "Axial View",
        calciumscore : "Calcium Score",
        calciumriskclassification : "Calcium Risk Classification"
      },
      calciumScore: {
        title: "Calcium Volume & Score by Vessel",
        columns: ["Artery", "Volume (mm³)", "Score"],
        labels: {
          lm: "LM",
          lad: "LAD",
          lcx: "LCX",
          rca: "RCA",
          total: "Total",
        },
      },
      agatston: {
        title: "Agatston Score Risk Categories",
        columns: ["Agatston Score", "Risk Category"],
        labels: {
          none: "0 - None",
          minimal: "1-10 - Minimal",
          mild: "11-100 - Mild",
          moderate: "101-400 - Moderate",
          high: ">400 - High",
        },
      },
    },
  },
  stenosis:{
    title: 'Coronary Artery Stenosis Report',
    imageLabel:'3D Model',
    calciumScore:'Calcium Score',
    stenosisLegend:'Stenosis Legend',
    legends:[
      ['Normal','(0%)'],
      ['Minimal','(1-24%)'],
      ['Mild','(25-49%)'],
      ['Moderate','(50-69%)'],
      ['High','(≥70%)'],
    ],
    columns:['Vessel','Stenosis Plaque','Status']
  },
  fai:{
    title: 'Fat Attenuation Index Analysis Report'
  },
  plaque:{
    title : 'Plaque Analysis Report',
    columns: ['RCA', 'LAD', 'LCX', 'RCA lesion', 'LAD lesion', 'LCX lesion'],
    labels: {
      length: "Length (mm)",
      lumenVolume: "Lumen Volume (mm³)",
      plaqueVolume: "Plaque Volume (mm³)",
      vesselVolume: "Vessel Volume (mm³)",
      calcifiedPlaqueVolume: "Calcified Plaque Volume (mm³, %)",
      noncalcifiedPlaqueVolume: "Noncalcified Plaque Volume (mm³, %)",
      lowAttenuationPlaqueVolume: "Low Attenuation Plaque Volume (mm³, %)",
      percentAtheromaVolume: "Percent Atheroma Volume (%)",
      remodelingIndex: "Remodeling Index",
      // stenosisDegree: "Stenosis Degree (%)",
      minimumLumenArea: "Minimum Lumen Area (mm²)",
      minimumLumenDiameter: "Minimum Lumen Diameter (mm)",
      plaqueBurden: "Plaque Burden",
    },
  },
  ef:{
    title : 'Ejection Fraction Analysis Report',
    Rows: ['Parameter', 'LV', 'RV'],
    columns: ['Ejection Fraction', 'End Diastolic Volume', 'End Systolic Volume', 'Stroke Volume', 'End Diastolic Myocardial Volume', 'End Diastolic Myocardial Mass'],
    labels: {
      diastolic : 'Diastolic Phase',
      systolic : 'Systolic Phase',
      parameter : 'Cardiac Parameters',
      cycle : 'Cardiac Volume Throughout Cycle'
    }
  }
}


export const SEGMENTATION_CONTROLLER_NAMES = {
  la : 'LA',
  laWall : 'LA Wall',
  lv : 'LV',
  lvWall : 'LV Wall',
  ra : 'RA',
  raWall : 'RA Wall',
  rv : 'RV',
  rvWall : 'RV Wall',
  aorta : 'Aorta',
  coronary : 'Coronary',
  calcium : 'Calcium',
  epicardial: 'Epicardial',
  avc: 'AVC',
  lowAttenuation: 'LowAttenuation',
  calcified: 'Calcified',
  nonCalcified:'NonCalcified'
} as const;

export const DICOM_TAG_NAMES = {
  dicomTagModal : 'DICOM Tag Modal'
}

export const CAPTURE_MODAL_NAMES = {
  imagesavecopy : 'Image Save / Copy',
  filename : 'File name',
  imagesize : 'Image size',
  px : 'Px',
  w : 'W',
  h : 'H'
}

export const FAI_REPORT_MODAL_NAMES = {
  fatattenuationindex : 'Fat Attenuation Index Analysis Report',
  vesselviews : 'Vessel Views',
  huhistogram : 'HU Histogram',
  icctable : 'ICC Table',
  rairegion : 'RAI Regoin',
  interobservervariability : 'Interobserver variability',
  icc : 'ICC',
  confidenceinterval : '95% Confidence Interval'
}

export const SEGMENTATION_MODAL_NAMES ={
  segmentationManagerHud : 'Segmentation Manager HUD',
  segmentation : 'Segmentation',
  rename : 'Rename',
  recolor : 'Recolor',
  transparency : 'Transparency'
}

export const THICKNESS_CONTROLLER_NAMES = {
  method: 'Method',
  methods: {
    MIP: 'MIP',
    MinIP: 'MinIP',
    Average: 'Average',
  },
  thickness: 'Thickness',
  reset: 'Reset',
};
export const CT_PRESET_CONTENT_NAMES ={
  preset: 'Preset',
  editor: 'Editor',
  label: 'Label',
  windowWidth: 'Window Width',
  windowLevel: 'Window Level',
  add: 'Add',
  modify: 'Modify',
  remove: 'Remove'
}
export const CT_PRESET_ITEM_NAMES = {
  default: 'Default',
  fullDynamic: 'Full Dynamic',
  abdomen: 'Abdomen',
  angio: 'Angio',
  bone: 'Bone',
  chest: 'Chest',
  lungs: 'Lungs',
  negative: 'Negative',
} as const;

export const VR_PRESET_ITEM_NAMES = {
  angio: 'Angio',
  airways: 'Airways',
  bonesAndSkin1: 'Bones and skin1',
  bonesAndSkin2: 'Bones and skin2',
  bonesAndSkin3: 'Bones and skin3',
  bonesBW: 'Bones B/W',
  skinBW: 'Skin B/W',
  MIPBW: 'MIP B/W',
  MIPBWInverse: 'MIP B/W Inverse',
} as const;

export const ModalResponse = {
  FILL_ALL_FIELDS: "Please fill in all fields.",
  PASSWORD_MISMATCH: "Passwords do not match.",
  PASSWORD_SELF_ONLY: "Only you can change your password.",
  PASSWORD_INVALID: "Min 8 chars, use 2 types (letters, numbers, symbols).",
  PASSWORD_SAME: "New password cannot be the same as the current password.",
  PASSWORD_CHANGED_FAIL: "Password change failed. Please try again.",
  INCORRECT_OLD_PASSWORD: "Current password is incorrect.",
  NAME_SELF_ONLY: "You can enter only your own ID."
};

export const CT_PRESET_EDITOR_NAME = 'Editor';

// 만약 다국어가 필요하면, 별도의 구조로 확장할 수 있음.
